export interface Diamond {
  size: number
  polish: string
  delivery_time: number
  last_update: string
  depth: number
  status: string
  institute: string
  symmetry: string
  fluorescence: string
  length: number
  width: number
  colored: boolean
  color: string
  cut: string
  table: number
  order: string
  supplier: string
  clarity: string
  order_date: string
  special_offer: string
  height: number
  form: string
  price: number
  type: string
  fancy_intensity: string
  certificate: string
  special: boolean
  link?: string
  image_url?: string
}

export type DiamondsState = {
  diamonds: Record<string, Diamond>;
};

const state = (): DiamondsState => ({
  diamonds: {},
});

const getters = {
  getDiamondById: (state: DiamondsState) => (id: string): Diamond | null => {
    return state.diamonds[id] || null;
  },
};

const actions = {
  async fetchDiamond({ commit, state }: any, diamondId: string): Promise<Diamond | null> {
    if (state.diamonds[diamondId]) {
      return state.diamonds[diamondId];
    }

    if (diamondId === null || diamondId.length < 8) return null;

    commit('loading/actionStarted', null, { root: true });
    try {
      const response = await fetch(`https://diamonds.api.rubin-trauringe.de/diamond/${diamondId}`);
      if (response.ok) {
        const data = await response.json();
        commit('setDiamond', { diamondId, data });
        return data;
      }
    } catch (error) {
      console.error('Error fetching diamond:', error);
    } finally {
      commit('loading/actionFinished', null, { root: true });
    }
    return null;
  },
};

const mutations = {
  setDiamond(state: DiamondsState, { diamondId, data }: { diamondId: string; data: Diamond }): void {
    state.diamonds[diamondId] = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
